module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.showTaxes) ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('p', [_c('a', {
    directives: [{
      name: "smooth-scroll",
      rawName: "v-smooth-scroll"
    }],
    staticClass: "make-link",
    attrs: {
      "href": "https://movemais.com/api/v2/archeion/downloadFileArcheion/tabela-de-tarifas-movemais"
    }
  }, [_vm._v("\n          *Conheça nossos valores de recarga.\n        ")])])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, _vm._l((_vm.typeSelected.values), function(taxas) {
    return _c('div', {
      key: taxas.id
    }, [_c('div', {
      class: taxas.classLastChildInLine ?
        'box-recharge-' + taxas.classLastChildInLine :
        'box-recharge',
      staticStyle: {
        "margin-bottom": "2rem"
      }
    }, [_c('div', {
      class: 'recharge-' + taxas.colorClass
    }, [_c('div', {
      class: 'recharge-value-' + taxas.colorClass
    }, [_vm._v("R$")]), _vm._v(" "), _c('div', {
      class: 'recharge-label-' + taxas.colorClass
    }, [_vm._v("\n              " + _vm._s(taxas.rechargeValue) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "recharge-tax-label"
    }, [_vm._v("\n              Taxa de Recarga:\n              "), _c('p', [_vm._v(_vm._s(_vm._f("cents")(taxas.rechargeTax)))])])]), _vm._v(" "), (taxas.additionalInformation) ? _c('small', [_vm._v(_vm._s(taxas.additionalInformation))]) : _vm._e()])])
  }), 0)])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row",
    attrs: {
      "id": "rechargeB2B"
    }
  }, [_c('div', {
    staticClass: "col-xs-12 margin-b10"
  }, [_c('h3', {
    staticClass: "bold upper"
  }, [_vm._v("Recargas")]), _vm._v(" "), _c('p', [_vm._v("As recargas estão sujeitas a taxas, verifique os valores:")])])])
}]}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-369c3ae7!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/card-taxes.vue
// module id = 2093
// module chunks = 1